import type { ReactElement } from 'react';
import { AgentResourcesProvider } from './AgentResources.Container';
import { ContextSelectorContainer } from './ContextSelector.Container';
import { ChatHeaderController } from './Header.Controller';

type Props = {
  showContextDisplayOverride?: boolean;
};

function ChatHeader(props: Props): ReactElement {
  return (
    <ContextSelectorContainer>
      <AgentResourcesProvider>
        <ChatHeaderController showContextDisplayOverride={props.showContextDisplayOverride} />
      </AgentResourcesProvider>
    </ContextSelectorContainer>
  );
}

export { ChatHeader };
